import {
  ApiClient,
  StorageAdapter,
  SessionAdapter,
  LoggerAdapter,
  LoginResponse,
} from '@email-ferret/shared';
import { getStoredToken, setStoredToken, removeStoredToken } from './auth/token-utils';
import { getSessionWithTimeout } from './auth/session-utils';
import { logger } from './logger';

// Re-export types for backward compatibility
export type { LoginResponse };

const API_BASE_URL = typeof window !== 'undefined' ? '' : process.env.NEXT_PUBLIC_API_URL || '';

const webStorage: StorageAdapter = {
  getToken: () => getStoredToken(),
  setToken: (token) => setStoredToken(token),
  removeToken: () => removeStoredToken(),
};

const webSession: SessionAdapter = {
  getSession: (timeoutMs) => getSessionWithTimeout(timeoutMs),
  signOut: async () => {
    try {
      const { supabase } = await import('./supabase');
      await supabase.auth.signOut();

      // Redirect to home page after sign out (only in browser environment)
      if (typeof window !== 'undefined') {
        window.location.href = '/';
      }
    } catch (error) {
      logger.warn('Failed to sign out during token refresh failure', { error });
      // Still attempt redirect even if signOut fails
      if (typeof window !== 'undefined') {
        window.location.href = '/';
      }
    }
  },
};

const webLogger: LoggerAdapter = {
  info: (msg, ctx) => logger.info(msg, ctx),
  warn: (msg, ctx, err) => logger.warn(msg, ctx, err),
  error: (msg, ctx, err) => logger.error(msg, ctx, err),
  debug: (msg, ctx) => logger.debug(msg, ctx),
};

export const api = new ApiClient({
  baseUrl: API_BASE_URL,
  storage: webStorage,
  session: webSession,
  logger: webLogger,
});
